import { deleted, get, post, put } from 'utils/api';
import { MASTER_DATA_API_URL } from 'utils/constants';
import { DataResponse } from '../response';

export interface DataCategory {
  stt: number;
  categoryId: string;
  categoryCode: string;
  categoryName: string;
  categoryType?: string;
  khoiLuongGpmt?: number;
  actived: boolean;
}

export interface SearchCategoryPayload {
  paging: {
    pageSize: number;
    pageIndex: number;
    orderBy?: string;
    orderByDesc?: string;
  };
  categoryCode?: string;
  categoryName?: string;
  productTypeId?: number;
  actived?: boolean;
}

export interface ICategoryMdServices {
  searchCategory(data: SearchCategoryPayload): Promise<DataResponse<Array<DataCategory>>>;
  getCategoryById(categoryId: string): Promise<DataResponse<DataCategory>>;
  createCategory(data: Omit<DataCategory, 'stt' | 'categoryId'>): Promise<DataResponse<boolean>>;
  updateCategory(categoryId: string, data: Omit<DataCategory, 'stt' | 'categoryId'>): Promise<DataResponse<boolean>>;
  deleteCategory(categoryId: string): Promise<DataResponse<boolean>>;
}

export function createCategoryMdServices(): ICategoryMdServices {
  return {
    searchCategory: async (data) => {
      return (await post(MASTER_DATA_API_URL, `category/search`, data)).data;
    },
    getCategoryById: async (categoryId) => {
      return (await get(MASTER_DATA_API_URL, `category/${categoryId}`)).data;
    },
    createCategory: async (data) => {
      return (await post(MASTER_DATA_API_URL, `category/create`, data)).data;
    },
    updateCategory: async (categoryId, data) => {
      return (await put(MASTER_DATA_API_URL, `category/update/${categoryId}`, data)).data;
    },
    deleteCategory: async (categoryId) => {
      return (await deleted(MASTER_DATA_API_URL, `category/delete/${categoryId}`)).data;
    },
  };
}


